import { render, staticRenderFns } from "./BlogCarrousel.vue?vue&type=template&id=68c5f44c&scoped=true"
import script from "./BlogCarrousel.vue?vue&type=script&lang=js"
export * from "./BlogCarrousel.vue?vue&type=script&lang=js"
import style1 from "./BlogCarrousel.vue?vue&type=style&index=1&id=68c5f44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c5f44c",
  null
  
)

export default component.exports